"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _store = _interopRequireDefault(require("./redux/store"));

var _reactRouterDom = require("react-router-dom");

var _views = _interopRequireDefault(require("./views"));

var _reactCssThemeSwitcher = require("react-css-theme-switcher");

var _AppConfig = require("./configs/AppConfig");

var themes = {
  dark: "".concat(process.env.PUBLIC_URL, "/css/dark-theme.css"),
  light: "".concat(process.env.PUBLIC_URL, "/css/light-theme.css")
};

var App = function App() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "App"
  }, /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: _store.default
  }, /*#__PURE__*/_react.default.createElement(_reactCssThemeSwitcher.ThemeSwitcherProvider, {
    themeMap: themes,
    defaultTheme: _AppConfig.THEME_CONFIG.currentTheme,
    insertionPoint: "styles-insertion-point"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/clPortal/",
    component: _views.default
  }))))));
}; // export default App;


exports.App = App;